import { Box, ButtonGroup, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { StyledButton } from '../Admin/Communication/Communication.styles'
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'
import { usePreboardingTabContext } from './PreboardingTabProvider'

type TabOption = 'preboarding-summary' | 'hired-candidates' | 'all-candidates'

const Preboarding = () => {
    const { tenant } = useParams<{ tenant: string }>();
    const navigate = useNavigate();
    const location = useLocation(); // ✅ Needed to track current route
    const { showFilter, setShowFilter, selectedOption, setSelectedOption } = usePreboardingTabContext();


    const handleTabClick = (option: TabOption) => {
        setSelectedOption(option)
        navigate(`/${tenant}/preboarding/${option}`);
    }

    useEffect(() => {
        const path = location.pathname.split("/").pop();

        if (location.pathname === `/${tenant}/preboarding`) {
            navigate(`/${tenant}/preboarding/preboarding-summary`, { replace: true });
            setSelectedOption("preboarding-summary");
        } else if (path && ["hired-candidates", "all-candidates"].includes(path)) {
            setSelectedOption(path as typeof selectedOption);
        }
    }, [location.pathname, navigate, tenant]);

    return (
        <Box sx={{ marginLeft: '2.3vw', marginRight: '1.3vw' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.2vw', mb: '0.7vw' }}>
                <Typography variant='h5'>{selectedOption === 'preboarding-summary' ? 'Preboarding Summary' : selectedOption === 'hired-candidates' ? 'Hired Candidates' : 'Preboarding Candidates'}</Typography>
                {selectedOption === 'preboarding-summary' && (
                    <Typography variant='subtitle1'>
                        At-a-Glance
                    </Typography>
                )}
            </Box>

            {/* Tabs */}
            <Box display="flex" justifyContent="space-between" sx={{ maxWidth: '50vw' }}>
                <ButtonGroup variant="outlined" sx={{ width: '100%' }}>
                    <StyledButton
                        variant="outlined"
                        sx={{ mr: 0.13, flexGrow: 1, fontWeight: 500 }}
                        isselected={selectedOption === 'preboarding-summary'}
                        onClick={() => handleTabClick('preboarding-summary')}
                    >
                        Preboarding Summary
                    </StyledButton>

                    <StyledButton
                        variant="outlined"
                        sx={{ flexGrow: 1, fontWeight: 500 }}
                        isselected={selectedOption === 'all-candidates'}
                        onClick={() => handleTabClick('all-candidates')}
                    >
                        {showFilter}
                    </StyledButton>

                    <StyledButton
                        variant="outlined"
                        sx={{ flexGrow: 1, fontWeight: 500 }}
                        isselected={selectedOption === 'hired-candidates'}
                        onClick={() => handleTabClick('hired-candidates')}
                    >
                        Hired Candidates
                    </StyledButton>




                </ButtonGroup>
            </Box>

            <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ width: '100%', mb: '1.6vw' }}>
                <Outlet />
            </Box>
        </Box>
    )
}

export default Preboarding
